import { Component, OnInit, AfterContentChecked, Input } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-turns-reports-card',
  templateUrl: './turns-reports-card.component.html',
  styleUrls: ['./turns-reports-card.component.scss']
})
export class TurnsReportsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('reports-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('reports-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.length;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('reports-counts-spinner');
    }
  }
}
